/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Controls_Aria_LabelInputs */

const en_style_guide_controls_aria_label = /** @type {(inputs: Style_Guide_Controls_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Style Guide Controls`)
};

const fr_style_guide_controls_aria_label = /** @type {(inputs: Style_Guide_Controls_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controles du guide de style`)
};

const de_style_guide_controls_aria_label = /** @type {(inputs: Style_Guide_Controls_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Styleguide-Steuerelemente`)
};

const it_style_guide_controls_aria_label = /** @type {(inputs: Style_Guide_Controls_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controlli della guida di stile`)
};

const ru_style_guide_controls_aria_label = /** @type {(inputs: Style_Guide_Controls_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Элементы управления стилем`)
};

const es_style_guide_controls_aria_label = /** @type {(inputs: Style_Guide_Controls_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controles de la guía de estilo`)
};

const zh_cn2_style_guide_controls_aria_label = /** @type {(inputs: Style_Guide_Controls_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`样式指南控件`)
};

const ja_style_guide_controls_aria_label = /** @type {(inputs: Style_Guide_Controls_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スタイルガイドコントロール`)
};

const hi_style_guide_controls_aria_label = /** @type {(inputs: Style_Guide_Controls_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्टाइल गाइड नियंत्रण`)
};

const pt_pt2_style_guide_controls_aria_label = /** @type {(inputs: Style_Guide_Controls_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controles do guia de estilo`)
};

/**
* | output |
* | --- |
* | "Style Guide Controls" |
*
* @param {Style_Guide_Controls_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_controls_aria_label = /** @type {((inputs?: Style_Guide_Controls_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Controls_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_controls_aria_label(inputs)
	if (locale === "de") return de_style_guide_controls_aria_label(inputs)
	if (locale === "it") return it_style_guide_controls_aria_label(inputs)
	if (locale === "ru") return ru_style_guide_controls_aria_label(inputs)
	if (locale === "es") return es_style_guide_controls_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_controls_aria_label(inputs)
	if (locale === "ja") return ja_style_guide_controls_aria_label(inputs)
	if (locale === "hi") return hi_style_guide_controls_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_controls_aria_label(inputs)
	return en_style_guide_controls_aria_label(inputs)
});